export default class ParseError extends Error {
	public constructor(message: string) {
		super(message);
	}
}
